// Messages d'erreur généraux
export const ERROR_TEXTS = {
  failedToFetch: 'Échec de la récupération des utilisateurs',
  repositoryQueryFailed: 'Échec de la récupération des données',
  repositoryNotFound: 'Ressource non trouvée',
  userNotFound: 'Utilisateur non trouvé',
  permissionDenied: 'Permission refusée',
  unknownError: 'Une erreur inconnue s\'est produite',
  unknownAuthenticationError: 'ERREUR_AUTHENTIFICATION_INCONNUE',
  failedToLoadDashboard: 'Échec du chargement du tableau de bord'
} as const;